import React, { FC } from 'react';
import FileCreateModal from '@/core/components/UI/modals/FileCreateModal';
import { ProvidedModal, useModal } from '@/core/components/UI/modals/ModalProvider';
import { Trans } from '@lingui/react/macro';
import { useRequestUserUpdateMutation } from '@/features/account/services/Account.service';
import { UploadedFile } from '@/core/types';
import { NotificationStore } from '@wunder/ui-components';
import { t } from '@lingui/core/macro';

interface MembershipCardModalT extends ProvidedModal {}

const MembershipCardModal: FC<MembershipCardModalT> = ({ opened }) => {
  const [updateUser] = useRequestUserUpdateMutation();
  const { hideModal } = useModal();

  const onFilesCreated = (files: (UploadedFile | undefined)[]) => {
    const membershipAsset = files?.[0];

    if (membershipAsset) {
      return updateUser({ fileIds: [membershipAsset.id] })
        .unwrap()
        .then(() => {
          NotificationStore.addNotification({
            type: 'success',
            title: t({ id: 'general.notification.success', message: 'Success' }),
            content: t({
              id: 'account.notification.membershipCardUploaded',
              message: 'Membership card is under review, this can take a few days.',
            }),
          });
        });
    }
  };

  return (
    <FileCreateModal
      opened={opened}
      onCancel={hideModal}
      accept={{ 'image/jpeg': ['.jpg', '.png', '.jpeg'] }}
      description={
        <Trans id="account.priceDetails.membershipCardDescription">
          Enjoy exclusive benefits by uploading your membership card. <br />
          Please note: All cards are subject to approval, and the review process may take a few
          days.
        </Trans>
      }
      onFilesCreated={onFilesCreated}
    />
  );
};

export default MembershipCardModal;
